import React, { useEffect, useState } from 'react'
import "./SwitchFbModal.css"
import SponsorIcon from "../../../assets/icons/sponsor.svg"
import { useDispatch, useSelector } from 'react-redux';
import { fbActions } from '../../../store/fb-slice';
import UNIVERSAL from '../../../config/config';
import { PuffLoader } from "react-spinners"

const SwitchFbModal = (props) => {
    const [allPages, setAllPages] = useState();
    const dispatch = useDispatch();
    const user = useSelector(state => state?.user?.user);
    const [selectedFbPage, setSelectedFbPage] = useState();
    const [showLoadingSpinner, setShowLoadingSpinner] = useState(false);
    const {userData}=props;

    function closeModal() {
        props.closeModal();
    }

    function handleSelectedFbPage(id) {
        if (selectedFbPage && selectedFbPage.id === id) {
            return;
        } else {
            const selected = allPages.find(allId => allId.id === id);
            setSelectedFbPage(selected);
        }
    }

    async function handleSelectedFbPageDone() {
        return fetch(UNIVERSAL.BASEURL_1 + '/bizv2/switch_facebook_page', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': '6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe',
            },
            body: JSON.stringify({
                "app_fb_user_id": Number(userData?.app_fb_user_id),
                "business_id": String(user?.app_business_id),
                "page_data": selectedFbPage
            })
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson)
                props.closeModal();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    useEffect(() => {
        async function getUserFbPages() {
            setShowLoadingSpinner(true);
            return fetch(UNIVERSAL.BASEURL_1 + '/bizv2/facebook/pages', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': '6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe',
                },
                body: JSON.stringify({
                    "business_id": String(user?.app_business_id),
                    "next": ""
                })
            })
                .then((response) => response.json())
                .then((responseJson) => {
                    if (responseJson.data) {
                        setAllPages(responseJson.data.fb_pages);
                        setShowLoadingSpinner(false);
                    } else {
                        // error
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
        getUserFbPages();
    }, [])

    return (
        <div className="modalBg">
            <div class="modal" tabindex="-1">
                <div class="modal-dialog modal-fbPageDialog">
                    <div class="modal-content">
                        <div className="modalClose">
                            <img className='categoryModalClose' src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/close-circle.svg" alt="close-modal-img" onClick={closeModal} />
                        </div>
                        <div className="modal-main">
                            <div className="modalHeading">
                                <h6 className='modal-heading'>Your Facebook Pages</h6>
                                <p className='modal-subHeading'>Select your facebook page</p>
                                <hr className='stepsHr' />
                            </div>
                            <div className="linkedFbPageInfo">
                                {showLoadingSpinner && (
                                    <div className="puffLoadingSpinner">
                                    <PuffLoader size={100} color="#0F6EFF" />
                                  </div>
                                )}
                                {allPages && allPages.map(data => {
                                    return (
                                        <div className='linkedFbPagesInfo' key={data.id}>
                                            <span className='linkedFbPage-info'>
                                                <img className='linkedFbPage-img' src={`https://graph.facebook.com/${data.id}/picture`} alt="linked-fb-page-img" />
                                                <span className='linkedFbpage-details'>
                                                    <p className='linkedFbPage-name'>{data.name.length > 15 ? data.name.slice(0, 15) + "..." : data.name}</p>
                                                    <p className='linkedFbPage-sponsor'>Sponsored <img className='linkedFbPage-sponsor-icon' src={SponsorIcon} alt="sponsor-img" /></p>
                                                </span>
                                            </span>
                                            <button className='linkedFbPage-switch' onClick={e => handleSelectedFbPage(data.id)}>{selectedFbPage?.id === data?.id ? 'Selected' : 'Select'}</button>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="fbPagesModalBtn">
                                <button className='categoryModalDoneBtn' onClick={handleSelectedFbPageDone}>Done</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SwitchFbModal